import { OPEN_OFFICIAL_RATING_POPUP, CLOSE_OFFICIAL_RATING_POPUP } from "../actions";

export const initialState = {
	show: false,
	userId: null,
	federation: null,
	federationName: null,
	rating: null as any,
};

export type OfficialRatingState = typeof initialState;

export default function (state = initialState, action) {
	switch (action.type) {
		case OPEN_OFFICIAL_RATING_POPUP: {
			return {
				show: true,
				userId: action.uuid,
				federationName: action.federationName,
				federation: action.federation,
			};
		}

		case CLOSE_OFFICIAL_RATING_POPUP: {
			return { ...state, show: false };
		}

		case "@@router/LOCATION_CHANGE": {
			return { ...state, show: false, userId: null };
		}

		default:
			return state;
	}
}
